import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/base/api-service';
import {
  CreateMarketProfileData,
  MarketProfile,
  MarketProfileCollectionResponse,
  UpdateMarketProfileData,
} from './market-profile.model';
import EmptyResponse from '../shared/model/misc';

@Injectable({
  providedIn: 'root'
})

export class MarketProfileService extends ApiService {

  private restApiUrl = this.apiUrl('admin/market-profile');

  constructor(private httpClient: HttpClient) {
    super();
  }

  public find(id: string): Observable<MarketProfile> {
    return this.httpClient.get<MarketProfile>(this.restApiUrl + '/' + id)
  }

  public findPaginated(
    page: number = 1,
    pageSize: number = 25,
    sortBy: string = 'name',
    sortDirection: string = 'desc',
    filter: string = '',
  ): Observable<MarketProfileCollectionResponse> {
    const queryParams = new HttpParams()
      .append('page', page.toString())
      .append('page_size', pageSize.toString())
      .append('sort_by', sortBy)
      .append('sort_direction', sortDirection)
      .append('filter', filter.trim());

    return this.httpClient
      .get<MarketProfileCollectionResponse>(this.restApiUrl, {params: queryParams})
  }

  public create(payload: CreateMarketProfileData): Observable<EmptyResponse> {
    return this.httpClient
      .post<EmptyResponse>(this.restApiUrl, payload)
  }

  public update(marketProfileId: string, payload: UpdateMarketProfileData): Observable<EmptyResponse> {
    return this.httpClient
      .put<EmptyResponse>(this.restApiUrl + '/' + marketProfileId, payload)
  }

  public delete(marketProfileId: string) {
    return this.httpClient
      .delete<any>(this.restApiUrl + '/' + marketProfileId)
  }
}
